import { Icon, IconProps } from "../";

export const SocialFacebookIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path d="M23 12C23 5.9247 18.0742 1 12 1C5.9247 1 1 5.9247 1 12C1 17.4901 5.0227 22.0408 10.2807 22.8658V15.1801H7.4878V12H10.2807V9.5767C10.2807 6.8201 11.9241 5.2966 14.4365 5.2966C15.6399 5.2966 16.8983 5.5122 16.8983 5.5122V8.2182H15.5112C14.145 8.2182 13.7182 9.0663 13.7182 9.9364V12H16.7696L16.2823 15.1801H13.7182V22.8658C18.9773 22.0408 23 17.4901 23 12Z" />
    </Icon>
  );
};
